import { render, staticRenderFns } from "./BusinessEmployeesPage.vue?vue&type=template&id=73136c02&scoped=true"
import script from "./BusinessEmployeesPage.vue?vue&type=script&lang=js"
export * from "./BusinessEmployeesPage.vue?vue&type=script&lang=js"
import style0 from "./BusinessEmployeesPage.vue?vue&type=style&index=0&id=73136c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73136c02",
  null
  
)

export default component.exports